import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
const partnerLinks = ['sglonelyguy.me', 'ttvip.life', 'locanto.space', 'kkbaby.site', 'sgbeautycastle.live', 'shiok8.xyz', 'geylang777.info', 'geylang666.me', 'isyou.net', 'ttvip-62.site', 'shiok26.site', 'sgharem.site', 'xfy8.com', '新加坡芽笼网666', 'geylang 666', 'geylang666.net', '芽籠666', '亞龍666', '芽笼666', '亚龙666', 'geylang777', 'geylang777.net', '新加坡TTVIP-temp', 'TTVIP57', 'TTVIP58', 'TTVIP-57.com', '新加坡4ni52是你网', 'geylang666是你网', 'isyou-47.com', '新加坡千金网', '新加坡寂寞男人', 'sgvipclubs', '新加坡金沙网', '新加坡陌陌网', '新加坡倾城网', '新加坡幸福缘', '新加坡芽笼', '芽笼18巷', '新加坡芽笼收费', '新加坡芽笼哪家店好', '新加坡芽笼几点开门', '新加坡芽笼中国妹子', '新加坡红灯区', '新加坡约炮', '新加坡约炮服务', '新加坡约炮网', '新加坡美女约炮', '新加坡小姐网', '新加坡找小姐', '新加坡外围', '新加坡高端外围', '新加坡外围嫩模', '新加坡外围伴游', '新加坡陪游服务', '新加坡美女伴游', '新加坡上门服务', '新加坡全套服务', '新加坡一条龙服务', '新加坡按摩', '新加坡上门按摩', '新加坡SPA按摩', '新加坡上门spa', '新加坡24小时spa', '新加坡大保健', '新加坡妓女', '新加坡下水', 'singapore按摩', 'singapore小姐', 'singapore特殊服务', '新加坡模特', '新加坡酒店上门', '新加坡spa推荐', '新加坡芽笼价格', '新加坡散炮', '新加坡男士spa', '新加坡自由身', '新加坡KB', '新加坡口爆服务', '新加坡楼凤', '新加坡OUTCALL', '新加坡INCALL', '新加坡半套', '新加坡性息', '新加坡邪骨', '新加坡水疗服务', '新加坡娱乐', '新加坡推拿', '新加坡推拿服务', '新加坡一楼一凤', 'singapore massage', 'SG Escort', 'Singapore Escorts', 'Singapore call girl', '新加坡SPA推荐', '新加坡美女上门', '新加坡推油', '新加坡推油按摩', '新加坡桑拿服务', '新加坡桑拿会所', '新加坡美女按摩', '新加坡桑拿网', '新加坡桑拿按摩论坛', '新加坡夜生活', '新加坡小姐服务', '新加坡酒店按摩', '新加坡酒店小姐', '新加坡包夜服务', '新加坡小妹服务', '新加坡哪里找小妹', '新加坡约妹子', '新加坡电招妓女', '新加坡约炮APP', '新加坡快餐服务', '新加坡全身推油', '新加坡男士SPA', '新加坡SPA排行榜', '新加坡24小时约炮', '新加坡小姐2025', '新加坡ONS', '新加坡一夜快乐', '新加坡成人约炮', '新加坡成人网', '新加坡援交', '新加坡养生SPA', '新加坡洗浴', '新加坡足交', '新加坡拔龙筋', '新加坡抓龙根', '新加坡亚龙网', '芽笼越南花园', '新加坡kkbaby', '新加坡kk网', '新加坡kkbaby.com', '新加坡熟女', 'sglonelyguy47', '新加坡找小姐服务', '新加坡狼友', 'sgbeautycastle', '新加坡sgbeautycastle', '新加坡美丽城堡', '新加坡后宫网', 'sg后宫网', 'sgharem', 'sgwolf', '新加坡狼群网sgwolf', '新加坡陌陌时代', '打造新加坡最大的美女约炮平台'];
export function ContactCTA() {
  return <section id="contact" className="py-32 bg-dark-900 relative overflow-hidden" data-id="element-159">
      {/* Gold Glow Background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-160"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10 text-center" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-162">
          <h2 className="text-4xl md:text-6xl font-serif text-white mb-6" data-id="element-163">
            开启您的<span className="text-gold-500" data-id="element-164">尊享体验</span>
          </h2>
          <p className="text-gold-200/60 uppercase tracking-[0.2em] mb-12" data-id="element-165">
            Begin Your Premium Experience
          </p>

          <div className="p-1 rounded-2xl bg-gradient-to-r from-transparent via-gold-500/30 to-transparent mb-16" data-id="element-166">
            <div className="bg-dark-800 rounded-xl p-8 md:p-12 border border-white/5 backdrop-blur-sm" data-id="element-167">
              <p className="text-gray-400 mb-8 leading-relaxed" data-id="element-168">
                访问我们的官方网站，浏览更多精选佳丽，开启您的尊享之旅。
                <br data-id="element-169" />
                <span className="text-gray-500 text-sm" data-id="element-170">
                  Visit our official website to explore more elite companions.
                </span>
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-171">
                <motion.a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center justify-center gap-3 px-12 py-5 bg-gold-500 hover:bg-gold-400 text-dark-900 font-medium tracking-widest uppercase transition-colors shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-172">
                  <ExternalLink size={20} data-id="element-173" />
                  <span data-id="element-174">新加坡春风阁 | CFGE</span>
                </motion.a>
              </div>
            </div>
          </div>

          {/* Partner Links / 友站链接 */}
          <div className="mt-8" data-id="element-175">
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-176">
              <div className="h-px w-16 bg-gradient-to-r from-transparent to-gold-500/30" data-id="element-177"></div>
              <h3 className="text-lg font-serif text-gold-500/80" data-id="element-178">友站链接</h3>
              <div className="h-px w-16 bg-gradient-to-l from-transparent to-gold-500/30" data-id="element-179"></div>
            </div>
            <div className="flex flex-wrap justify-center gap-x-1.5 gap-y-1 max-w-5xl mx-auto" data-id="element-180">
              {partnerLinks.map((link, index) => <a key={index} href="https://www.geylang777-6.site" target="_blank" rel="noopener noreferrer" className="text-[11px] text-gray-600 hover:text-gold-400 transition-colors duration-300 px-1.5 py-0.5" data-id="element-181">
                  {link}
                  {index < partnerLinks.length - 1 && <span className="text-gray-800 ml-1.5" data-id="element-182">/</span>}
                </a>)}
            </div>
          </div>

          <p className="text-gray-700 text-xs mt-10" data-id="element-183">
            Strictly confidential. Members only.
          </p>
        </motion.div>
      </div>
    </section>;
}